var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 2C17.855 2 22.332 6.477 22.332 12C22.332 17.523 17.855 22 12.332 22C6.80903 22 2.33203 17.523 2.33203 12C2.33203 6.477 6.80903 2 12.332 2ZM12.332 4C10.2103 4 8.17547 4.84285 6.67518 6.34315C5.17489 7.84344 4.33203 9.87827 4.33203 12C4.33203 14.1217 5.17489 16.1566 6.67518 17.6569C8.17547 19.1571 10.2103 20 12.332 20C14.4538 20 16.4886 19.1571 17.9889 17.6569C19.4892 16.1566 20.332 14.1217 20.332 12C20.332 9.87827 19.4892 7.84344 17.9889 6.34315C16.4886 4.84285 14.4538 4 12.332 4ZM12.332 6C12.577 6.00003 12.8134 6.08996 12.9964 6.25272C13.1794 6.41547 13.2964 6.63975 13.325 6.883L13.332 7V11.586L16.039 14.293C16.2184 14.473 16.3225 14.7144 16.3303 14.9684C16.338 15.2223 16.2488 15.4697 16.0808 15.6603C15.9127 15.8508 15.6785 15.9703 15.4256 15.9944C15.1726 16.0185 14.92 15.9454 14.719 15.79L14.625 15.707L11.625 12.707C11.4696 12.5514 11.3698 12.349 11.341 12.131L11.332 12V7C11.332 6.73478 11.4374 6.48043 11.6249 6.29289C11.8125 6.10536 12.0668 6 12.332 6Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time-clock.563acdb6debfcfbcd0203e26c91104f7.svg";
export { ForwardRef as ReactComponent };